var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"life-amount flex_wrap"},_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"life-amount-item flex_center",class:{ 'amount-active': _vm.modelValue === item },style:({
    marginBottom: (index + 1) < _vm.list.length - 1 ? _vm.marginBottom: 0,
    fontSize: _vm.size,
    height: _vm.height
  }),on:{"click":function($event){return _vm.amountChange(item)}}},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-23879dbf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/life-amount.vue
// module id = null
// module chunks = 